import React, { Fragment } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { useNavigate } from "react-router";

// components
import { RightArrow } from "components/common";

// utils
import { moneyFormatter } from "utils";

const TodaysSales = ({ saleData, ...props }) => {
  const navigate = useNavigate();
  const sections = [
    {
      key: "all",
      label: "총 판매액",
      className: "active",
      valueCount: saleData.bpayCount + saleData.crmCount,
      valueAmount: saleData.totalAmount,
    },
    {
      key: "bpay",
      label: "b.pay",
      valueCount: saleData.bpayCount,
      valueAmount: saleData.bpayAmount,
    },
    {
      key: "crm",
      label: "현장판매",
      valueCount: saleData.crmCount,
      valueAmount: saleData.crmAmount,
    },
    {
      key: "refund",
      label: "환불",
      valueCount: saleData.refundCount,
      valueAmount: saleData.refundAmount,
    },
  ];

  const renderSections = () => {
    return sections.map((section, index) => {
      return (
        <Fragment key={section.key}>
          <StatsWrapper>
            <div>
              <StatTitle>{section.label}</StatTitle>
              <span className={section.className}>
                &middot; {section.valueCount ? section.valueCount : 0}건
              </span>
            </div>
            <StatAmount className={section.className}>
              {moneyFormatter(section.valueAmount)}
            </StatAmount>
          </StatsWrapper>

          {index === 0 && <Divider />}
        </Fragment>
      );
    });
  };

  return (
    <MainWrapper onClick={() => navigate("/sales")}>
      <CardTitleWrapper>
        <Title>오늘의 매출</Title>
        <RightArrow size="S" />
      </CardTitleWrapper>

      {renderSections()}
    </MainWrapper>
  );
};

const MainWrapper = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 12px;
  padding: 24px;
  border-radius: 12px;
  height: 246px;
  background-color: ${(props) => props.theme.colors.cardBackground};
`;

const Divider = styled.div`
  width: 100%;
  border-bottom: 1px solid #f2f2f4;
  margin-top: 6px;
  margin-bottom: 18px;
`;

const CardTitleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 18px;
`;

const Title = styled.p`
  font-weight: bold;
  font-size: 18px;
  line-height: 24px;
  color: ${(props) => props.theme.colors.primaryTextColor};
`;

const StatsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding-bottom: 12px;
  &.bottom-padding {
  }

  div {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
  }

  span {
    font-size: 14px;
    line-height: 20px;
    margin-left: 4px;
    color: ${(props) => props.theme.colors.secondaryTextColor};
    &.active {
      color: ${(props) => props.theme.colors.activeTextColor};
    }
  }
`;

const StatTitle = styled.p`
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${(props) => props.theme.colors.primaryTextColor};
`;

const StatAmount = styled.p`
  font-feature-settings: "tnum" on, "lnum" on;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: -0.2px;
  color: ${(props) => props.theme.colors.primaryTextColor};

  &.active {
    font-size: 18px;
    font-weight: bold;
    color: ${(props) => props.theme.colors.activeTextColor};
  }
`;

TodaysSales.propTypes = {
  totalCount: PropTypes.number,
  totalAmount: PropTypes.number,
  bpayCount: PropTypes.number,
  bpayAmount: PropTypes.number,
  crmCount: PropTypes.number,
  crmAmount: PropTypes.number,
  refundCount: PropTypes.number,
  refundAmount: PropTypes.number,
  onClick: PropTypes.func,
};

export default TodaysSales;
